module.exports = __webpack_public_path__ + "media/cars-backgournd-small.942cb873.mp4";